import axios from 'axios'

export function setAuthToken (token) {
  console.log('Set axios bearer from utils, token is: ' + token);
  axios.defaults.headers.Authorization = 'Bearer ' + token;
}